import { useEffect,useRef, useState } from 'react';
import { AutoSizer,List, WindowScroller } from 'react-virtualized';

import usePreferredLocale from '@/hooks/usePreferredLocale';
import useScreenSize from '@/hooks/useScreenSize';
import { getCategoryDisplayEntries } from '@/utils/categoryTaxonomy';

import CategoryItem from './CategoryItem';

import './styles/Color.css';

export default function Color({ query, setQuery }) {
  const [scrollElement, setScrollElement] = useState(null);
  const locale = usePreferredLocale();
  const items = getCategoryDisplayEntries('color', locale);
  const scrollElementRef = useRef();
  const screenSize = useScreenSize();
  const listRef = useRef();

  useEffect(()=>{
    setScrollElement(scrollElementRef.current);
  }, []); 

  useEffect(()=>{
    listRef.current?.recomputeRowHeights();
  }, [screenSize]);

  function selectItem(item) {
    if(query.color) {
      setQuery({ ...query, color: [...query.color, item.value] });
    } else {
      setQuery({ ...query, color: [item.value] });
    }
  }

  function removeItem(item) {
    setQuery({ ...query, color: query.color.filter(color => color !== item.value) });
  }

  return (
    <>
      <div className="search-filters-content-color-virtual-list" ref={scrollElementRef}>
        {scrollElement && <WindowScroller scrollElement={scrollElement}>
          {({ height, isScrolling, onChildScroll, scrollTop }) => (
            <AutoSizer disableHeight>
              {({ width }) => (
                <List
                  autoHeight
                  width={width ? width : 0.1}
                  height={height ? height : 0} 
                  isScrolling={isScrolling}
                  onScroll={onChildScroll}
                  rowCount={items.length}
                  rowHeight={50}
                  scrollTop={scrollTop}
                  overscanRowCount={5}
                  ref={listRef}
                  rowRenderer={({ index, key, style }) => (
                    <div key={key} style={style}>
                      <CategoryItem 
                        displayText={items[index].label}
                        isSelected={query.color?.some(color => color === items[index].value)}
                        selectItem={() => selectItem(items[index])}
                        removeItem={() => removeItem(items[index])}
                      />
                    </div>
                  )}
                />
              )}
            </AutoSizer>
          )}
        </WindowScroller>}
      </div>
    </>
  );
}
